import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance1vspt3xrdob1a as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { OBJECT_getInstance1yzfkijr6copj as OBJECT_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from '../descriptors/SerialDescriptors.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
  return (p0) => p0.x1m();
}
var ObjectSerializerClass;
function ObjectSerializer() {
  if (ObjectSerializerClass === VOID) {
    class $ {
      constructor(serialName, objectInstance) {
        this.h20_1 = objectInstance;
        this.i20_1 = emptyList();
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.j20_1 = lazy(tmp_0, () => {
          var tmp = OBJECT_getInstance();
          return buildSerialDescriptor(serialName, tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.k1n_1 = this.i20_1;
            return Unit_instance;
          });
        });
      }
      x1m() {
        var tmp0 = this.j20_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
        return tmp0.s3();
      }
      r1n(encoder, value) {
        encoder.o1r(this.x1m()).p1r(this.x1m());
      }
      y1m(encoder, value) {
        return this.r1n(encoder, !(value == null) ? value : THROW_CCE());
      }
      z1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.x1m();
        var composite = decoder.o1r(descriptor);
        var tmp$ret$0;
        $l$block_0: {
          if (composite.e1s()) {
            tmp$ret$0 = Unit_instance;
            break $l$block_0;
          }
          var index = composite.f1s(this.x1m());
          if (index === -1) {
            tmp$ret$0 = Unit_instance;
            break $l$block_0;
          } else
            throw SerializationException().s1o('Unexpected index ' + index);
        }
        var result = tmp$ret$0;
        composite.p1r(descriptor);
        return this.h20_1;
      }
    }
    initMetadataForClass($, 'ObjectSerializer', VOID, VOID, [KSerializer()]);
    ObjectSerializerClass = $;
  }
  return ObjectSerializerClass;
}
//region block: exports
export {
  ObjectSerializer as ObjectSerializer2kjkucmygguwd,
};
//endregion

//# sourceMappingURL=ObjectSerializer.mjs.map
